import axiosClient from "../../utils/axiosInstance";

export const upvoteBlogAsync = (id: any) => {
  const response = axiosClient().put("/blog/vote/" + id);
  return response;
};

export const bookmarkBlogAsync = (id: string) => {
  const response = axiosClient().put("/blog/bookmark/" + id);
  return response;
};

export const copyBlogAsync = (id: string) => {
  const response = axiosClient().post("/blog/document/copy/" + id);
  return response;
};

export const updateBlogView = (id: string) => {
  const response = axiosClient().put("/blog/view/" + id);
  return response;
};

